import React, { useEffect, useState, useContext } from "react";
import { DrtContext } from "../../../context/DrtContext";
import ReactPaginate from "react-paginate";
import { axiosBaseURLExternal } from "../../../httpCommon";
import archiveDate from "../../../services/Date";

const AuctionNotice = () => {
  const [loading, setLoading] = useState(false);
  const [showArchive, setShowArchive] = useState(false);
  const [selectedDratLocationId, setSelectedDratLocationId] = useState("100");
  const [selectedDrtLocationId, setSelectedDrtLocationId] = useState("");
  const [drtDratLocationName, setDrtDratLocationName] = useState(
    "DEBT RECOVERY APPELLATE TRIBUNAL - DELHI"
  );
  const [publicationNotices, setPublicationNotices] = useState([]);
  const [dratLocations, setDratLocations] = useState([]);

  const fetchDratLocations = async () => {
    try {
      const res = await axiosBaseURLExternal.post("getDrtDratScheamName");
      setDratLocations(res.data);
    } catch (error) {
      console.error("Error fetching DRAT locations:", error);
      setDratLocations([]);
    }
  };

  useEffect(() => {
    fetchDratLocations();
    fetchPublicationNotices(selectedDratLocationId);
    fetchDrtLocations(selectedDratLocationId);
  }, [selectedDratLocationId, showArchive]);

  const getDrtDratName = (id) => {
    try {
      let name = dratLocations.filter((item) => item.schemeNameDrtId === id);
      setDrtDratLocationName(name[0]?.SchemaName);
    } catch (error) {
      console.error("Error getting DRAT name:", error);
      setDrtDratLocationName("");
    }
  };

  const [drtLocationsDropdown, setDrtLocationsDropdown] = useState([]);
  const fetchDrtLocations = async (id) => {
    try {
      const data = { schemeNameDratId: id };
      const res = await axiosBaseURLExternal.post("getDrtSchemaName", data);
      setDrtLocationsDropdown(res.data);
    } catch (error) {
      console.error("Error fetching DRT locations:", error);
      setDrtLocationsDropdown([]);
    }
  };

  const fetchPublicationNotices = async (id) => {
    try {
      setLoading(true);
      const data = { schemeNameDrtId: id };
      const res = await axiosBaseURLExternal.post("getPublicationNotice", data);
      if (showArchive) {
        setPublicationNotices(
          res.data.map((item, index) => ({ ...item, sr: index + 1 }))
        );
      } else {
        const twelveMonthsAgo = archiveDate();
        const filteredEntries = res.data.filter((item) => {
          const noticeDate = parseDate(item.publicnoticdate);
          return noticeDate >= twelveMonthsAgo;
        });
        setPublicationNotices(
          filteredEntries.map((item, index) => ({ ...item, sr: index + 1 }))
        );
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching publication notices:", error);
      setPublicationNotices([]);
      setLoading(false);
    }
  };

  const parseDate = (dateString) => {
    const [day, month, year] = dateString.split("/");
    return new Date(`${year}-${month}-${day}`);
  };

  const doubleDigitDate = (date) => {
    if (date) {
      let arr = date.split("/");
      if (arr[0].length === 1) arr[0] = "0" + arr[0];
      if (arr[1].length === 1) arr[1] = "0" + arr[1];
      return arr.join("/");
    }
  };

  const itemsPerPage = 10;
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [startListNo, setStartListNo] = useState(0);

  useEffect(() => {
    const endListNo = startListNo + itemsPerPage;
    setCurrentItems(
      publicationNotices ? publicationNotices.slice(startListNo, endListNo) : []
    );
    setPageCount(Math.ceil(publicationNotices?.length / itemsPerPage));
  }, [startListNo, itemsPerPage, publicationNotices]);

  const handlePageClick = (event) => {
    const newStartListNo =
      (event.selected * itemsPerPage) % publicationNotices.length;
    setStartListNo(newStartListNo);
  };

  useEffect(() => {
    if (selectedDrtLocationId !== "")
      fetchPublicationNotices(selectedDrtLocationId);
    else fetchPublicationNotices(selectedDratLocationId);
  }, [showArchive]);

  return (
    <>
      <div className="row">
        <div className="col-12 mb-4 d-flex justify-content-between align-items-center flex-wrap">
          <div className="w-25">
            <h2>Publication Notice</h2>
          </div>

          <div className="w-75 d-flex flex-wrap">
            <div className="w-50 pr-3">
              <label
                htmlFor="dratSelect"
                className="sr-only"
              >
                Select DRAT
              </label>
              <select
                id="dratSelect"
                className="form-control"
                aria-label="Select DRAT Location"
                onChange={(e) => {
                  setSelectedDratLocationId(e.target.value);
                  fetchDrtLocations(e.target.value);
                  getDrtDratName(e.target.value);
                  fetchPublicationNotices(e.target.value);
                  setDrtLocationsDropdown([]);
                }}
                value={selectedDratLocationId}
              >
                {dratLocations &&
                  dratLocations
                    .filter((item) => parseInt(item.schemeNameDrtId) >= 100)
                    .map((item, index) => (
                      <option value={`${item.schemeNameDrtId}`} key={index}>
                        {item.SchemaName}
                      </option>
                    ))}
              </select>
            </div>

            <div className="w-50 pr-3">
              <label
                htmlFor="drtSelect"
                className="sr-only"
              >
                Select DRT
              </label>
              <select
                id="drtSelect"
                className="form-control"
                aria-label="Select DRT Location"
                onChange={(e) => {
                  fetchPublicationNotices(e.target.value);
                  getDrtDratName(e.target.value);
                  setSelectedDrtLocationId(e.target.value);
                }}
              >
                <option hidden>Select DRT</option>
                {drtLocationsDropdown &&
                  drtLocationsDropdown.map((item, index) => (
                    <option value={item.schema_id} key={index}>
                      {item.name}
                    </option>
                  ))}
              </select>
            </div>
          </div>
        </div>

        <div className="col-12 notice-db">
          <button
            className="btn btn-warning mb-3"
            aria-label={
              showArchive
                ? "Show last 12 months notices"
                : "Show archived notices"
            }
            onClick={() => setShowArchive(!showArchive)}
          >
            {showArchive
              ? "Show last 12 months Notices"
              : "Show Archive"}
          </button>

          <div className="table-responsive">
            <table
              className="table table-striped common-table tender"
              aria-label="Auction Notice Table"
            >
              <thead>
                <tr>
                  <th scope="col">Sl.No.</th>
                  <th scope="col">DRT/DRAT Name</th>
                  <th scope="col">Notice Title</th>
                  <th scope="col">Notice Issue Date</th>
                  <th scope="col">Document</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="5">
                      <h6 className="loader">Loading ...</h6>
                    </td>
                  </tr>
                ) : currentItems.length > 0 ? (
                  currentItems.map((item, index) => (
                    <tr key={index}>
                      <td>{item.sr}</td>
                      <td>{drtDratLocationName}</td>
                      <td>{item.massage}</td>
                      <td>{doubleDigitDate(item.publicnoticdate)}</td>
                      <td>
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href={item.auctionurl}
                          aria-label={`Open document for ${item.massage}`}
                        >
                          <i
                            className="fas fa-file-pdf"
                            aria-hidden="true"
                          ></i>
                          <span className="sr-only">PDF Document</span>
                        </a>
                        <br />
                        <small>size 589kb</small>
                        <br />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5">
                      <p>No Data Found ...</p>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div className="col-12">
          <div className="nav-pagination mb-5">
            <ReactPaginate
              breakLabel="..."
              nextLabel="next >"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={pageCount}
              previousLabel="< previous"
              renderOnZeroPageCount={null}
              aria-label="Pagination Navigation"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default AuctionNotice;
